export interface RatingScale {
  uId?: string | null;
  name?: string;
  description?: string;
  createdOn?: string;
  updatedOn?: string;
  createByName?: string;
  createdById?: string;
  updatedByName?: string;
  updatedById?: string;
  isActive?: boolean;
  ratingArea: RatingArea;
  configuration?: Record<string, any>;
  levels?: RatingScaleLevel[];
  mapping?: RatingScaleMapping[];
}

export interface RatingScaleLevel {
  uId?: string | null;
  level: number;
  label?: string;
  name?: string;
  description?: string;
  htmlColorCode?: string;
  textColor?: string;
  options?: RatingScaleOptions;
  cultureCode?: string;
  configuration?: Record<string, any>;
  translations?: RatingScaleTranslation[];
}

export interface RatingScaleMapping {
  srcLevel: number;
  destLevel: number;
}

export enum RatingScaleOptions {
  None = 0,
  ShowLevels = 1
}

export enum RatingArea {
  None = 0,
  Notification = 1,
  Alert = 2,
  HorizonLocationIntelRatings = 3,
  Custom = 4
}

export interface RatingScaleTranslation {
  uId?: string;
  cultureCode: string;
  label: string;
  name: string;
  description: string;
}
